import Vue from 'vue'
import config from '@/config/index'

// === 注册 Element UI 的 Loading 服务 ===
import { Loading } from 'element-ui'
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
// 全局 loading 实例（不能放 this 上）
let loadingInstance = null

// ========= 屏幕状态（只监听一次） =========
const screen = Vue.observable({
  windowWidth: window.innerWidth,
  isWide: window.innerWidth >= 800
})

window.addEventListener('resize', () => {
  screen.windowWidth = window.innerWidth
  screen.isWide = screen.windowWidth >= 800
})

// ========= 上传失败提示方法（放在导出对象外面） =========
Vue.prototype.$showUploadError = function(successCallback) {
  return this.$msgbox({
    message: `
    <div style="color: red; font-size: 18px; font-weight: bold; margin-bottom: 10px;">
     上传失败
    </div>
      <div style="text-align: center; padding: 5px 0;">
        <p style="color: #000000; font-size: 18px; line-height: 1.5; margin: 0;">
          请确认文件格式<br>或 联系客服处理
        </p>
      </div>
    `,
    dangerouslyUseHTMLString: true,
    showCancelButton: true,
    confirmButtonText: '查看格式要求',
    cancelButtonText: '关闭',
    center: true,
    customClass: 'custom-upload-error-msgbox' // 添加自定义类
  }).then(() => {
    if (typeof successCallback === 'function') {
      successCallback()
    }
  }).catch(() => {
    // 点击"关闭"或取消按钮，什么都不做
  })
}

 //this.$common.downloadFile(url, name); 即可调用
export default {
  screen, // 🔥 直接挂上去，全局可用
// ========= 工具方法集合 =========
  DownLoad (url) {
     //console.log('调用了全局的下载：', url);
     // 直接使用浏览器下载
     //window.location.href = `${config.baseUrl}/${url}`
     const fullUrl = this.getFullUrl(url)
     const fileName = this.getFileName(url)
     this.downloadFile(fullUrl, fileName)
   },
  // 拼接完整下载 URL
  getFullUrl(relativePath) {
    if (relativePath.startsWith('http')) return relativePath;
    let base = config.baseUrl;
    if (!base.endsWith('/')) base += '/';
    return base + relativePath.replace(/^\/?/, '');
  },

  // 获取文件名
  getFileName(url) {
    if (url) {
      return url.substring(url.lastIndexOf('/') + 1);
    }
    return '结果';
  },

  // 单个和批量下载  都用的这个    创建隐藏的iframe 进行下载
  downloadFile(url, fileName) {

     // 判断是否为 TXT 文件（忽略大小写）
    const isTxt = /\.txt$/i.test(fileName);
    if (isTxt) {
      //console.log('TXT下载--地址：', url,fileName)
      this.downloadFileTXT(url, fileName)
      return;
    }
    //console.log('其他类型下载--地址：', url,fileName)
    const iframe = document.createElement('iframe');
        iframe.style.display = 'none'; // 隐藏 iframe
        iframe.src = url;
        document.body.appendChild(iframe);
  },
  //下载TXT 测试
  async downloadFileTXT(url, fileName) {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('HTTP ' + res.status);

      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fileName;      // 同源 blob URL，download 一定生效
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    } catch (e) {
      console.error('下载失败：', e);
      // 可选：失败时回退到 iframe 方案
    }
  },
 // 单个文件下载 没有调用 这个代码目前没用
  downloadFile1(url, fileName) {
    //console.log('下载地址：', url)
    //console.log('文件名：', fileName)
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  },
  // 批量下载多个文件 没有调用 这个代码目前没用
  batchDownloadFiles1(files, getFullUrl, downloadFile, onFinish, delay = 800) {
    let count = 0;

    const downloadNext = () => {
      if (count >= files.length) {
        onFinish?.(); // 下载完成的回调
        return;
      }

      const item = files[count];
      const fullUrl = getFullUrl(item.ZipUrl);
      const fileName = item.UpLoadFileName;

      downloadFile(fullUrl, fileName + '.zip');
      count++;
      setTimeout(downloadNext, delay);
    };

    downloadNext();
  },
  //隐藏if下载模式 没有调用
  batchDownloadFiles(files, getFullUrl, downloadFile, onFinish, delay = 800) {
    console.log('所有下载已触发1!!!@#!@#!@#');
    if (!files?.length) return;

      let completed = 0;

      files.forEach((item, index) => {
        const fullUrl = getFullUrl(item.ZipUrl);

        // 打开新窗口下载
        const win = window.open(fullUrl, '_blank');

        // 可选：提示用户关闭窗口
        if (!win) {
          console.warn('浏览器阻止了弹出窗口，请允许弹出窗口');
        }

        completed++;
        if (completed === files.length) {
          console.log('所有下载已触发');
          // onFinish?.();
        }
      });
  },



  //判断产品是否一致,目前因为页面问题 导致检测页面和左上角产品不一致,如果不一致,跳转工作台
  checkProductName(productName, router) {
      try {
        const productData = JSON.parse(window.localStorage.getItem('ProductData'))
        const localName = productData?.ProductName || ''
        if (localName !== productName) {
          console.warn(`ProductName不一致，跳转到 /control 页面`)
          router.push('/control')
          return false
        }
        return true
      } catch (error) {
        console.error('读取ProductData失败:', error)
        router.push('/control')
        return false
      }
    },

    //显示遮罩层
     showLoading() {
        if (!loadingInstance) {
          loadingInstance = Loading.service({
            lock: true,
            text: '文件上传中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.4)'
          })
        }
      },

      hideLoading() {
        if (loadingInstance) {
          loadingInstance.close()
          loadingInstance = null
        }
      }

}
